<template>
  <div class="card card-body shadow-sm mt-0">
    <div class="container">
      <!-- Cabeçalho -->
      <div class="form-header d-flex align-items-center justify-content-between mb-4">
        <h4 class="form-title mb-0">
          Detalhes do Perfil de Usuário
        </h4>
        <button class="btn btn-secondary btn-sm" @click="voltar">Voltar</button>
      </div>

      <!-- Dados do Perfil -->
      <FormSection title="Dados do Perfil" class="mb-4 form-section">
        <div class="row">
          <div class="col-md-5">
            <p><strong>Nome do Perfil:</strong> {{ perfil.nome }}</p>
          </div>
          <div class="col-md-5">
            <p><strong>Descrição:</strong> {{ perfil.descricao }}</p>
          </div>
          <div class="col-md-2">
            <p><strong>Peso:</strong> {{ perfil.peso }}</p>
          </div>
        </div>
      </FormSection>

      <!-- Permissões filtradas em grid de 5 colunas -->
      <FormSection title="Permissões" class="form-section">
        <div class="grid-permissoes">
          <div
            v-for="categoria in permissoesFiltradas"
            :key="categoria.nome"
            class="categoria-bloco"
          >
            <h6 class="categoria-titulo">{{ categoria.nome }}</h6>
            <ul class="ps-3 mb-0">
              <li v-for="acao in categoria.filtradasAcoes" :key="acao.value">
                <input type="checkbox" disabled :checked="perfil.permissoes.includes(acao.value)" :aria-label="acao.text" /> {{ acao.text }}
              </li>
            </ul>
          </div>
        </div>
      </FormSection>
    </div>
  </div>
</template>

<script>
import { gestaoPermissions } from '@/config/gestaoPermissions'
import { convert } from '@/utils/gestaoPolicy'
import { reactive, ref, computed, onMounted } from 'vue'
import FormSection from '@/components/Layout/FormSection.vue'
import { useRoute, useRouter } from 'vue-router'
import axios from '@/services/axios'

export default {
  components: { FormSection },
  setup() {
    const route = useRoute()
    const router = useRouter()

    const perfil = reactive({
      id: null,
      nome: '',
      descricao: '',
      peso: '',
      permissoes: [],
    })

        const permissoes = ref([

        // Administrador
        {
            nome: "Administrador",
            acoes: [
            { value: "administrador", text: "Administrador" },
            ],
        },


        // Dashboard

        {
          nome: 'Cards',
          acoes: [
            { value: 'cards_aulas_avulsas', text: 'Aulas Avuslas' },
            { value: 'cards_aulas_reposicao', text: 'Aulas de Reposição' },
            { value: 'cards_aulas_experimentais', text: 'Aulas Experimentais' },
            { value: 'cards_faltas_avisadas', text: 'Faltas Avisadas' },
            { value: 'cards_plano_vencer', text: 'Planos a Vencer' },
            { value: 'cards_prospects', text: 'Prospects' },
            { value: 'cards_matriculas_ativas', text: 'Matrículas Ativas' },
            { value: 'cards_trocas_nivel_turma', text: 'Trocas de Nível' },
          ],
        },
        {
          nome: 'Gráficos',
          acoes: [{ value: 'graficos_dashboard', text: 'Exibir' }],
        },
        {
          nome: 'Agenda de Turmas',
          acoes: [{ value: 'agendas_dashboard', text: 'Exibir' }],
        },
        {
          nome: 'Supervisões',
          acoes: [{ value: 'supervisoes_dashboard', text: 'Exibir' }],
        },
        {
          nome: 'Quedas não Comunicadas',
          acoes: [{ value: 'quedas_dashboard', text: 'Exibir' }],
        },
        {
          nome: 'Protocolos de Queda',
          acoes: [{ value: 'protocolos_queda_dashboard', text: 'Exibir' }],
        },

        {
          nome: 'Faltas não Comunicadas',
          acoes: [{ value: 'faltas_dashboard', text: 'Exibir' }],
        },

        {
          nome: 'Renovação Antecipada',
          acoes: [{ value: 'renovacao_antecipada_dashboard', text: 'Exibir' }],
        },

        {
          nome: 'Envio e-mail Troca de Nível / Certificado',
          acoes: [{ value: 'troca_nivel_envio_dashboard', text: 'Exibir' }],
        },

        {
          nome: 'Envio de Avaliações',
          acoes: [{ value: 'enviar_avaliacoes', text: 'Exibir' }],
        },

        ...gestaoPermissions.categorias,

        // Cadastros

        {
          nome: 'Menu Cadastro',
          acoes: [{ value: 'menu_cadastro', text: 'Exibir' }],
        },
          {
            nome: 'Animais',
            acoes: [
              { value: 'listar_animais', text: 'Listar' },
              { value: 'adicionar_animais', text: 'Adicionar' },
              { value: 'alterar_animais', text: 'Alterar' },
              { value: 'excluir_animais', text: 'Excluir' },
              { value: 'detalhar_animais', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Brindes',
            acoes: [
              { value: 'listar_brindes', text: 'Listar' },
              { value: 'adicionar_brindes', text: 'Adicionar' },
              { value: 'alterar_brindes', text: 'Alterar' },
              { value: 'excluir_brindes', text: 'Excluir' },
              { value: 'detalhar_brindes', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Cargos de Funcionários',
            acoes: [
              { value: 'listar_cargos_funcionarios', text: 'Listar' },
              { value: 'adicionar_cargos_funcionarios', text: 'Adicionar' },
              { value: 'alterar_cargos_funcionarios', text: 'Alterar' },
              { value: 'excluir_cargos_funcionarios', text: 'Excluir' },
              { value: 'detalhar_cargos_funcionarios', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Categorias de Planos',
            acoes: [
              { value: 'listar_categorias_planos', text: 'Listar' },
              { value: 'adicionar_categorias_planos', text: 'Adicionar' },
              { value: 'alterar_categorias_planos', text: 'Alterar' },
              { value: 'excluir_categorias_planos', text: 'Excluir' },
              { value: 'detalhar_categorias_planos', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Categorias de Produtos',
            acoes: [
              { value: 'listar_categorias_produtos', text: 'Listar' },
              { value: 'adicionar_categorias_produtos', text: 'Adicionar' },
              { value: 'alterar_categorias_produtos', text: 'Alterar' },
              { value: 'excluir_categorias_produtos', text: 'Excluir' },
              { value: 'detalhar_categorias_produtos', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Convênios',
            acoes: [
              { value: 'listar_convenios', text: 'Listar' },
              { value: 'adicionar_convenios', text: 'Adicionar' },
              { value: 'alterar_convenios', text: 'Alterar' },
              { value: 'excluir_convenios', text: 'Excluir' },
              { value: 'detalhar_convenios', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Descontos',
            acoes: [
              { value: 'listar_descontos', text: 'Listar' },
              { value: 'adicionar_descontos', text: 'Adicionar' },
              { value: 'alterar_descontos', text: 'Alterar' },
              { value: 'excluir_descontos', text: 'Excluir' },
              { value: 'detalhar_descontos', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Funcionários',
            acoes: [
              { value: 'listar_funcionarios', text: 'Listar' },
              { value: 'adicionar_funcionarios', text: 'Adicionar' },
              { value: 'alterar_funcionarios', text: 'Alterar' },
              { value: 'excluir_funcionarios', text: 'Excluir' },
              { value: 'detalhar_funcionarios', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Níveis de Turmas',
            acoes: [
              { value: 'listar_niveis_turmas', text: 'Listar' },
              { value: 'adicionar_niveis_turmas', text: 'Adicionar' },
              { value: 'alterar_niveis_turmas', text: 'Alterar' },
              { value: 'excluir_niveis_turmas', text: 'Excluir' },
              { value: 'detalhar_niveis_turmas', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Período de Avaliações',
            acoes: [
              { value: 'listar_periodos_avaliacoes', text: 'Listar' },
              { value: 'adicionar_periodos_avaliacoes', text: 'Adicionar' },
              { value: 'alterar_periodos_avaliacoes', text: 'Alterar' },
              { value: 'excluir_periodos_avaliacoes', text: 'Excluir' },
              { value: 'detalhar_periodos_avaliacoes', text: 'Detalhar' },
              { value: 'aplicar_periodos_avaliacoes', text: 'Aplicar' },
            ],
          },

          {
            nome: 'Pessoas Físicas',
            acoes: [
              { value: 'listar_pessoas_fisicas', text: 'Listar' },
              { value: 'adicionar_pessoa_fisica', text: 'Adicionar' },
              { value: 'alterar_pessoa_fisica', text: 'Alterar' },
              { value: 'excluir_pessoa_fisica', text: 'Excluir' },
              { value: 'detalhar_pessoa_fisica', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Pessoas Jurídicas',
            acoes: [
              { value: 'listar_pessoas_juridicas', text: 'Listar' },
              { value: 'adicionar_pessoa_juridica', text: 'Adicionar' },
              { value: 'alterar_pessoa_juridica', text: 'Alterar' },
              { value: 'excluir_pessoa_juridica', text: 'Excluir' },
              { value: 'detalhar_pessoa_juridica', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Planos de Matrículas',
            acoes: [
              { value: 'listar_planos_matriculas', text: 'Listar' },
              { value: 'adicionar_planos_matriculas', text: 'Adicionar' },
              { value: 'alterar_planos_matriculas', text: 'Alterar' },
              { value: 'excluir_planos_matriculas', text: 'Excluir' },
              { value: 'detalhar_planos_matriculas', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Produtos e Estoque',
            acoes: [
              { value: 'listar_produtos', text: 'Listar' },
              { value: 'adicionar_produtos', text: 'Adicionar' },
              { value: 'alterar_produtos', text: 'Alterar' },
              { value: 'excluir_produtos', text: 'Excluir' },
              { value: 'detalhar_produtos', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Tipos de Planos',
            acoes: [
              { value: 'listar_tipos_planos', text: 'Listar' },
              { value: 'adicionar_tipos_planos', text: 'Adicionar' },
              { value: 'alterar_tipos_planos', text: 'Alterar' },
              { value: 'excluir_tipos_planos', text: 'Excluir' },
              { value: 'detalhar_tipos_planos', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Turmas',
            acoes: [
              { value: 'listar_turmas', text: 'Listar' },
              { value: 'adicionar_turmas', text: 'Adicionar' },
              { value: 'alterar_turmas', text: 'Alterar' },
              { value: 'excluir_turmas', text: 'Excluir' },
              { value: 'detalhar_turmas', text: 'Detalhar' },
            ],
          },




        // Operacional

        {
          nome: 'Menu Operacional',
          acoes: [{ value: 'menu_operacional', text: 'Exibir' }],
        },

          {
            nome: 'Aniversariantes',
            acoes: [{ value: 'listar_aniversariantes', text: 'Listar' }],
          },
          {
            nome: 'Aulas Avulsas',
            acoes: [
              { value: 'listar_aulas_avulsas', text: 'Listar' },
              { value: 'adicionar_aulas_avulsas', text: 'Adicionar' },
              { value: 'alterar_aulas_avulsas', text: 'Alterar' },
              { value: 'cancelar_aulas_avulsas', text: 'Cancelar' },
              { value: 'detalhar_aulas_avulsas', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Aulas de Reposição',
            acoes: [
              { value: 'listar_aulas_reposicao', text: 'Listar' },
              { value: 'adicionar_aulas_reposicao', text: 'Adicionar' },
              { value: 'alterar_aulas_reposicao', text: 'Alterar' },
              { value: 'excluir_aulas_reposicao', text: 'Excluir' },
              { value: 'detalhar_aulas_reposicao', text: 'Detalhar' },
              { value: 'reagendar_aulas_reposicao', text: 'Reagendar' },
            ],
          },
          {
            nome: 'Avaliações de Desempenho',
            acoes: [
              { value: 'listar_avaliacoes_desempenho', text: 'Listar' },
              { value: 'alterar_avaliacoes_desempenho', text: 'Alterar' },
              { value: 'detalhar_avaliacoes_desempenho', text: 'Detalhar' },
            ],
          },

          {
            nome: 'Responsáveis Ativos',
            acoes: [
              { value: 'listar_emarketing_respativos', text: 'Listar' },
            ],
          },

          {
            nome: 'Responsáveis Inativos',
            acoes: [
              { value: 'listar_emarketing_respinativos', text: 'Listar' },
            ],
          },

          {
            nome: 'Matrículas',
            acoes: [
              { value: 'listar_matriculas', text: 'Listar' },
              { value: 'adicionar_matriculas', text: 'Adicionar' },
              { value: 'operar_matriculas', text: 'Criar, alterar e renovar com recebimentos (somente matrículas)' },
              { value: 'alterar_matriculas', text: 'Alterar' },
              { value: 'excluir_matriculas', text: 'Excluir' },
              { value: 'detalhar_matriculas', text: 'Detalhar' },
              { value: 'trancar_matriculas', text: 'Trancar' },
              { value: 'destrancar_matriculas', text: 'Destrancar' },
              { value: 'cancelar_matriculas', text: 'Cancelar' },
              { value: 'reverter_cancelamento_matriculas', text: 'Reverter Cancelamento' },
              { value: 'alterar_direito_imagem_matriculas', text: 'Alterar imagem' },
            ],
          },
          {
            nome: 'Pós-vendas',
            acoes: [
              { value: 'listar_posvendas', text: 'Listar' },
              { value: 'adicionar_posvendas', text: 'Adicionar' },
              { value: 'realizar_posvendas', text: 'Realizar' },
              { value: 'alterar_posvendas', text: 'Alterar' },
              { value: 'excluir_posvendas', text: 'Excluir' },
              { value: 'detalhar_posvendas', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Prospecções',
            acoes: [
              { value: 'listar_prospeccao', text: 'Listar' },
              { value: 'adicionar_prospeccao', text: 'Adicionar' },
              { value: 'alterar_prospeccao', text: 'Alterar' },
              { value: 'excluir_prospeccao', text: 'Excluir' },
              { value: 'detalhar_prospeccao', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Protocolos de Queda',
            acoes: [
              { value: 'listar_protocolos_queda', text: 'Listar' },
            ],
          },
          // {
          //   nome: 'Saídas de Animais',
          //   acoes: [
          //     { value: 'listar_saidas_animais', text: 'Listar' },
          //     { value: 'adicionar_saidas_animais', text: 'Adicionar' },
          //     { value: 'alterar_saidas_animais', text: 'Alterar' },
          //     { value: 'excluir_saidas_animais', text: 'Excluir' },
          //     { value: 'detalhar_saidas_animais', text: 'Detalhar' },
          //   ],
          // },
          {
            nome: 'Renovações - Cancelamento',
            acoes: [
              { value: 'cancelar_renovacao', text: 'Cancelar' },
            ],
          },

          {
            nome: 'Supervisões',
            acoes: [
              { value: 'listar_supervisoes', text: 'Listar' },
              { value: 'alterar_supervisoes', text: 'Alterar' },
              { value: 'detalhar_supervisoes', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Turmas do Instrutor',
            acoes: [
              { value: 'listar_turmas_instrutor', text: 'Listar' },
              { value: 'registrar_chamada', text: 'Registrar Chamada' },
              { value: 'imprimir_chamada', text: 'Imprimir Chamada' },
              { value: 'detalhar_turmas_instrutor', text: 'Detalhar' },
            ],
          },



        // Loja

        {
          nome: 'Menu Loja',
          acoes: [{ value: 'menu_loja', text: 'Exibir' }],
        },

          {
            nome: 'Entrada de Produtos',
            acoes: [
              { value: 'listar_entradas', text: 'Listar' },
              { value: 'adicionar_entradas', text: 'Adicionar' },
              { value: 'alterar_entradas', text: 'Alterar' },
              { value: 'excluir_entradas', text: 'Excluir' },
              { value: 'detalhar_entradas', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Vendas de Produtos',
            acoes: [
              { value: 'listar_vendas', text: 'Listar' },
              { value: 'adicionar_vendas', text: 'Adicionar' },
              { value: 'alterar_vendas', text: 'Alterar' },
              { value: 'excluir_vendas', text: 'Excluir' },
              { value: 'detalhar_vendas', text: 'Detalhar' },
              { value: 'emitir_recibo_vendas', text: 'Emitir Recibo' },
            ],
          },




        // Financeiro

        {
            nome: 'Menu Financeiro',
            acoes: [{ value: 'menu_financeiro', text: 'Exibir' }],
        },
        {
          nome: 'Cobranças e Boletos',
          acoes: [
            {
              value: 'financeiro_cobrancas_visualizar',
              text: 'Visualizar',
            },
            {
              value: 'financeiro_cobrancas_operar',
              text: 'Operar',
            },
            {
              value: 'financeiro_cobrancas_configurar',
              text: 'Configurar',
            },
          ],
        },

          {
            nome: 'Contas Financeiras',
            acoes: [
              { value: 'listar_contas_financeiras', text: 'Listar' },
              { value: 'adicionar_contas_financeiras', text: 'Adicionar' },
              { value: 'alterar_contas_financeiras', text: 'Alterar' },
              { value: 'excluir_contas_financeiras', text: 'Excluir' },
              { value: 'detalhar_contas_financeiras', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Conciliação Bancária',
            acoes: [
              { value: 'listar_conciliacao_bancaria', text: 'Listar' },
              { value: 'importar_conciliacao_bancaria', text: 'Importar arquivos (conciliação automática exige Executar)' },
              { value: 'executar_conciliacao_bancaria', text: 'Executar conciliações' },
              { value: 'desfazer_conciliacao_bancaria', text: 'Desfazer vínculos' },
              { value: 'ajustar_conciliacao_bancaria', text: 'Ajustes contábeis (exige também a permissão financeira da ação)' },
              {
                value: 'gerenciar_identidades_conciliacao_bancaria',
                text: 'Gerenciar identidades'
              },
            ],
          },
          {
            nome: 'Despesas',
            acoes: [
              { value: 'listar_despesas', text: 'Listar' },
              { value: 'adicionar_despesas', text: 'Adicionar' },
              { value: 'alterar_despesas', text: 'Alterar' },
              { value: 'excluir_despesas', text: 'Excluir' },
              { value: 'detalhar_despesas', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Planos de Contas',
            acoes: [
              { value: 'listar_planos_contas', text: 'Listar' },
              { value: 'adicionar_planos_contas', text: 'Adicionar' },
              { value: 'alterar_planos_contas', text: 'Alterar' },
              { value: 'excluir_planos_contas', text: 'Excluir' },
              { value: 'detalhar_planos_contas', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Receitas Gerais',
            acoes: [
              { value: 'listar_receitas_gerais', text: 'Listar' },
              { value: 'adicionar_receitas_gerais', text: 'Adicionar' },
              { value: 'alterar_receitas_gerais', text: 'Alterar' },
              { value: 'excluir_receitas_gerais', text: 'Excluir' },
              { value: 'detalhar_receitas_gerais', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Receitas Planos',
            acoes: [
              { value: 'listar_receitas_planos', text: 'Listar' },
              { value: 'adicionar_receitas_planos', text: 'Adicionar' },
              { value: 'alterar_receitas_planos', text: 'Alterar' },
              { value: 'excluir_receitas_planos', text: 'Excluir' },
              { value: 'detalhar_receitas_planos', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Registros Financeiros',
            acoes: [
              { value: 'listar_registros_financeiros', text: 'Listar' },
              { value: 'adicionar_registros_financeiros', text: 'Adicionar' },
              { value: 'alterar_registros_financeiros', text: 'Alterar' },
              { value: 'excluir_registros_financeiros', text: 'Excluir' },
              { value: 'detalhar_registros_financeiros', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Subcontas',
            acoes: [
              { value: 'listar_subcontas', text: 'Listar' },
              { value: 'adicionar_subcontas', text: 'Adicionar' },
              { value: 'alterar_subcontas', text: 'Alterar' },
              { value: 'excluir_subcontas', text: 'Excluir' },
              { value: 'detalhar_subcontas', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Transferências entre Contas',
            acoes: [
              { value: 'listar_transferencias_contas', text: 'Listar' },
              { value: 'adicionar_transferencias_contas', text: 'Adicionar' },
              { value: 'alterar_transferencias_contas', text: 'Alterar' },
              { value: 'excluir_transferencias_contas', text: 'Excluir' },
              { value: 'detalhar_transferencias_contas', text: 'Detalhar' },
            ],
          },
          {
            nome: 'Valores',
            acoes: [
              { value: 'listar_valores', text: 'Listar' },
              { value: 'adicionar_valores', text: 'Adicionar' },
              { value: 'alterar_valores', text: 'Alterar' },
              { value: 'excluir_valores', text: 'Excluir' },
              { value: 'detalhar_valores', text: 'Detalhar' },
            ],
          },
          // {
          //   nome: 'Operadores de Pagamentos',
          //   acoes: [
          //     { value: 'listar_parametros_operadores', text: 'Listar' },
          //     { value: 'adicionar_parametros_operadores', text: 'Adicionar' },
          //     { value: 'alterar_parametros_operadores', text: 'Alterar' },
          //     { value: 'excluir_parametros_operadores', text: 'Excluir' },
          //     { value: 'detalhar_parametros_operadores', text: 'Detalhar' },
          //   ],
          // },
          // {
          //   nome: 'Meios de Pagamentos',
          //   acoes: [
          //     { value: 'listar_parametros_meios', text: 'Listar' },
          //     { value: 'adicionar_parametros_meios', text: 'Adicionar' },
          //     { value: 'alterar_parametros_meios', text: 'Alterar' },
          //     { value: 'excluir_parametros_meios', text: 'Excluir' },
          //     { value: 'detalhar_parametros_meios', text: 'Detalhar' },
          //   ],
          // },
          // {
          //   nome: 'Formas de Pagamentos',
          //   acoes: [
          //     { value: 'listar_parametros_formas', text: 'Listar' },
          //     { value: 'adicionar_parametros_formas', text: 'Adicionar' },
          //     { value: 'alterar_parametros_formas', text: 'Alterar' },
          //     { value: 'excluir_parametros_formas', text: 'Excluir' },
          //     { value: 'detalhar_parametros_formas', text: 'Detalhar' },
          //   ],
          // },
          // {
          //   nome: 'Bandeiras de Pagamentos',
          //   acoes: [
          //     { value: 'listar_parametros_bandeiras', text: 'Listar' },
          //     { value: 'adicionar_parametros_bandeiras', text: 'Adicionar' },
          //     { value: 'alterar_parametros_bandeiras', text: 'Alterar' },
          //     { value: 'excluir_parametros_bandeiras', text: 'Excluir' },
          //     { value: 'detalhar_parametros_bandeiras', text: 'Detalhar' },
          //   ],
          // },
          // {
          //   nome: 'Tipos de Pagamentos',
          //   acoes: [
          //     { value: 'listar_parametros_tipos', text: 'Listar' },
          //     { value: 'adicionar_parametros_tipos', text: 'Adicionar' },
          //     { value: 'alterar_parametros_tipos', text: 'Alterar' },
          //     { value: 'excluir_parametros_tipos', text: 'Excluir' },
          //     { value: 'detalhar_parametros_tipos', text: 'Detalhar' },
          //   ],
          // },
          // {
          //   nome: 'Taxas de Pagamentos',
          //   acoes: [
          //     { value: 'listar_parametros_taxas', text: 'Listar' },
          //     { value: 'adicionar_parametros_taxas', text: 'Adicionar' },
          //     { value: 'alterar_parametros_taxas', text: 'Alterar' },
          //     { value: 'excluir_parametros_taxas', text: 'Excluir' },
          //     { value: 'detalhar_parametros_taxas', text: 'Detalhar' },
          //   ],
          // },



        // Configurações

        {
          nome: 'Menu Configurações',
          acoes: [{ value: 'menu_configuracoes', text: 'Exibir' }],
        },

        {
          nome: "Usuários",
          acoes: [
            { value: "listar_usuarios", text: "Listar" },
            { value: "adicionar_usuarios", text: "Adicionar" },
            { value: "alterar_usuarios", text: "Alterar" },
            { value: "excluir_usuarios", text: "Excluir" },
            { value: "detalhar_usuarios", text: "Detalhar" },
          ],
        },

        {
            nome: "Perfis de Usuários",
            acoes: [
              { value: "listar_perfis_usuarios", text: "Listar" },
              { value: "adicionar_perfis_usuarios", text: "Adicionar" },
              { value: "alterar_perfis_usuarios", text: "Alterar" },
              { value: "excluir_perfis_usuarios", text: "Excluir" },
              { value: "detalhar_perfis_usuarios", text: "Detalhar" },
            ],
        },

        {
            nome: "Documentos",
            acoes: [
            { value: "listar_documentos", text: "Listar" },
            { value: "adicionar_documentos", text: "Adicionar" },
            { value: "alterar_documentos", text: "Alterar" },
            { value: "excluir_documentos", text: "Excluir" },
            { value: "detalhar_documentos", text: "Detalhar" },
            ],
        },

        {
            nome: "Recessos",
            acoes: [
            { value: "listar_recessos", text: "Listar" },
            { value: "adicionar_recessos", text: "Adicionar" },
            { value: "alterar_recessos", text: "Alterar" },
            { value: "excluir_recessos", text: "Excluir" },
            { value: "detalhar_recessos", text: "Detalhar" },
            { value: "aplicar_recessos", text: "Aplicar" },
            { value: "cancelar_recessos", text: "Cancelar" },
            ],
        },

        {
            nome: 'Empresa',
            acoes: [{ value: 'alterar_empresa', text: 'Alterar' }],
        },


        {
            nome: 'Formulários Avaliações',
            acoes: [
              { value: 'listar_formularios_avaliacoes', text: 'Listar' },
              { value: 'adicionar_formularios_avaliacoes', text: 'Adicionar' },
              { value: 'alterar_formularios_avaliacoes', text: 'Alterar' },
              { value: 'excluir_formularios_avaliacoes', text: 'Excluir' },
              { value: 'detalhar_formularios_avaliacoes', text: 'Detalhar' },
            ],
        },

        {
            nome: 'Parâmetros Categorias',
            acoes: [
              { value: 'listar_paramentros_categorias', text: 'Listar' },
              { value: 'adicionar_paramentros_categorias', text: 'Adicionar' },
              { value: 'alterar_paramentros_categorias', text: 'Alterar' },
              { value: 'excluir_paramentros_categorias', text: 'Excluir' },
              { value: 'detalhar_paramentros_categorias', text: 'Detalhar' },
            ],
        },

        {
            nome: 'Parâmetros Blocos',
            acoes: [
              { value: 'listar_paramentros_blocos', text: 'Listar' },
              { value: 'adicionar_paramentros_blocos', text: 'Adicionar' },
              { value: 'alterar_paramentros_blocos', text: 'Alterar' },
              { value: 'excluir_paramentros_blocos', text: 'Excluir' },
              { value: 'detalhar_paramentros_blocos', text: 'Detalhar' },
            ],
        },

        {
            nome: 'Parâmetros Questões',
            acoes: [
              { value: 'listar_paramentros_questoes', text: 'Listar' },
              { value: 'adicionar_paramentros_questoes', text: 'Adicionar' },
              { value: 'alterar_paramentros_questoes', text: 'Alterar' },
              { value: 'excluir_paramentros_questoes', text: 'Excluir' },
              { value: 'detalhar_paramentros_questoes', text: 'Detalhar' },
            ],
        },

        // {
        //     nome: 'Parâmetros Opções',
        //     acoes: [
        //       { value: 'listar_paramentros_opcoes', text: 'Listar' },
        //       { value: 'adicionar_paramentros_opcoes', text: 'Adicionar' },
        //       { value: 'alterar_paramentros_opcoes', text: 'Alterar' },
        //       { value: 'excluir_paramentros_opcoes', text: 'Excluir' },
        //       { value: 'detalhar_paramentros_opcoes', text: 'Detalhar' },
        //     ],
        // },

          {
            nome: 'Menu Ajuda',
            acoes: [{ value: 'menu_ajuda', text: 'Exibir' }],
          },

          {
            nome: 'Material',
            acoes: [
              { value: 'listar_material', text: 'Listar' },
              { value: 'adicionar_material', text: 'Adicionar' },
              { value: 'alterar_material', text: 'Alterar' },
              { value: 'excluir_material', text: 'Excluir' },
              { value: 'detalhar_material', text: 'Detalhar' },
            ],
          },

          {
            nome: 'Videoaulas [Manuais]',
            acoes: [
              { value: 'listar_videoaulas', text: 'Listar' },
              { value: 'adicionar_videoaulas', text: 'Adicionar' },
              { value: 'alterar_videoaulas', text: 'Alterar' },
              { value: 'excluir_videoaulas', text: 'Excluir' },
              { value: 'detalhar_videoaulas', text: 'Detalhar' },
            ],
          },

          // {
          //   nome: 'Quiz',
          //   acoes: [
          //     { value: 'exibir_quiz', text: 'Exibir' },
          //   ],
          // },

          // {
          //   nome: 'Montador de pista',
          //   acoes: [
          //     { value: 'exibir_montador_pista', text: 'Exibir' },
          //   ],
          // },

      ]);

    const permissoesFiltradas = computed(() => {
      return permissoes.value
        .map(categoria => ({
          nome: categoria.nome,
          filtradasAcoes: categoria.acoes.filter(acao =>
            gestaoPermissions.categorias.some(item => item.nome === categoria.nome) || perfil.permissoes.includes(acao.value)
          )
        }))
        .filter(categoria => categoria.filtradasAcoes.length > 0)
    })

    const carregarPerfil = async () => {
      const id = route.params.id
      if (!id) return router.push('/configuracoes/perfis-de-usuarios')
      try {
        const { data } = await axios.get(
          `/configuracoes/perfis-de-usuarios/${id}`
        )
        Object.assign(perfil, data)
        perfil.permissoes = convert(data.permissions || [])
      } catch {
        alert('Erro ao carregar dados do perfil.')
        router.push('/configuracoes/perfis-de-usuarios')
      }
    }

    const voltar = () => router.push('/configuracoes/perfis-de-usuarios')

    onMounted(carregarPerfil)

    return { perfil, permissoesFiltradas, voltar }
  },
}
</script>

<style scoped>
/* Faz o card centralizar e limitar largura */
.card { max-width: 1000px; margin: 0 auto; }

/* Fundo claro em todas as seções */
.form-section .card-body {
  background-color: #f8f9fa;
}

/* Grid fixo de 5 colunas */
.grid-permissoes {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 1rem;
  width: 100%;
}

/* Título de cada categoria */
.categoria-titulo {
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

/* Lista sem marcadores padrão */
ul { list-style: none; padding-left: 0; margin: 0; }

/* Container interno de lousa */
.container { padding: 0 15px; }

/* Form header e título */
.form-header { margin: 0; }
.form-title { text-align: left; margin: 0; }
</style>
